export const actions = {
  async getAll(state, data) {
    const filters = new URLSearchParams(data).toString()
    const res = await this.$axios.get(`/offers?${filters}`)
    return res.data
  },
  async filters(state) {
    const res = await this.$axios.get('/offers/filters')
    return res.data
  },
  async getProductCategory(state, data) {
    const { productCategory, ..._filters } = data
    const filters = new URLSearchParams(_filters).toString()
    const res = await this.$axios.get(
      `/product-category/${productCategory}?${filters}`
    )
    return res.data
  },
  async productCategoryFilters(state, data) {
    const res = await this.$axios.get(
      `/product-category/${data.productCategory}/filters`
    )
    return res.data
  },
}
